import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e2cff8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-group" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("董事会")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("监事会")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("高管")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.radiovalue,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radiovalue) = $event)),
          "button-style": "solid",
          onChange: _ctx.changeradio
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "ListDirector" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "ListSupervisor" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "ListExecutives" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onChange"])
      ], 512), [
        [_vShow, _ctx.showradio]
      ]),
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createVNode(_component_Table, {
              ref: "gglbtable",
              data: _ctx.data,
              columns: _ctx.columns,
              "expanded-row-render": true,
              bordered: true,
              pagination: _ctx.pag
            }, null, 8, ["data", "columns", "pagination"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createVNode(_component_Nodata, { nodatadesc: _ctx.nodatadesc }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}